






































































import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Enums
import { ProductTypes } from "@/data/enums/products";

// Typings
import { IProduct } from "@/models/products";
import {
  IProductProviderData,
  IProductProviderMethods
} from "@/models/providers/products";

@Component({
  components: {
    "multilevel-product-settings": () =>
      import(
        "@/components/app/admin/catalogue/products/multilevelCategories/multilevelProductSettings.vue"
      )
  }
})
export default class EditProductOptions extends Vue {
  // Inject

  @Inject({ from: "productProviderData" })
  public readonly $productProviderData!: () => IProductProviderData;

  public get $productData() {
    return this.$productProviderData();
  }

  @Inject({ from: "productProviderMethods" })
  public readonly $productProviderMethods!: IProductProviderMethods;

  // Propos

  @Prop({ required: true })
  public productId!: IProduct["id"];

  // Data

  public optionProductType = ProductTypes.PRODUCT_OPTION;
}
